import { cloneDeep, isEqual } from 'lodash-es';
import { DependencyList, EffectCallback, useEffect, useMemo, useRef } from 'react';

const useDeepCompareMemoize = <T>(value: T) => {
  const ref = useRef<T>(value);
  const signalRef = useRef<number>(0);

  if (!isEqual(value, ref.current)) {
    ref.current = cloneDeep(value);
    signalRef.current += 1;
  }

  return useMemo(() => ref.current, [signalRef.current]);
};

export const useWatchEffect = (callback: EffectCallback, dependencies: DependencyList): void => {
  return useEffect(callback, useDeepCompareMemoize(dependencies));
};
